import { Component } from 'react';
import store from '../configureStore';
import * as settingsActions from '../actions/settings';

export default class SmallWidgetContainer extends Component {
  constructor(props) {
    super(props);

    const {
      defaultSetting,
      defaultTranslation,
      exceededBookingsLimit,
      brandingVisualized,
      exceededTrialPlan,
      settings,
    } = this.props;

    store.dispatch(
      settingsActions.setConfiguration({
        ...settings,
        defaultSetting,
        defaultTranslation,
        exceededBookingsLimit,
        brandingVisualized,
        exceededTrialPlan,
      }),
    );
  }

  componentDidMount() {
    const { settings } = this.props;
    if (window.xprops && window.xprops.onInit) {
      window.xprops.onInit(settings.setting);
    }
  }
}
